import classNames from 'classnames';
import React from 'react';
import CodeSparkThemedTypography from '../../../../components/elements/CodeSparkThemedTypography';
import CtaButton from '../../../../components/elements/CtaButton';
import CtaButtonContainer from '../../../../components/elements/CtaButton/CtaButtonContainer';
import { SectionPaddingVertical, SectionWidth } from '../../../../components/global/Layout';
import { CTA_LABEL_FOR_DIFFERENT_TRIAL_LENGTHS } from '../../../../experiments/constants';
import { useExperimentContext } from '../../../../experiments/context';
import { useIsMobile } from '../../../../hooks/screenSizeHooks';
import { botClassName } from '../../../../utils/e2eBotUtils';
import { HeroLeft, HeroRightImage, HeroTitle, HeroWrapper, ValueProps } from './components';

const styles = require('./Hero.module.css');
const variantStyles = require('./HeroRedesign.module.css');

function HeroRedesign({ data, onCtaClick }) {
  const {
    title,
    valueProps,
    trialText,
    ctaLabel,
    heroImageMobile,
    heroImageDesktop,
    valuePropIcon,
    announcement,
  } = data;
  const {
    experiments: { differentPlanTrials },
  } = useExperimentContext();

  const heroImage = useIsMobile() ? heroImageMobile : heroImageDesktop;
  const btnCtaLabel = differentPlanTrials ? CTA_LABEL_FOR_DIFFERENT_TRIAL_LENGTHS : ctaLabel;

  return (
    <SectionPaddingVertical className={variantStyles.heroSection}>
      <SectionWidth>
        <HeroWrapper className={variantStyles.hero}>
          <HeroLeft>
            <HeroTitle className={variantStyles.heroTitle} parseText>
              {title}
            </HeroTitle>
            <ValueProps valuePropIcon={valuePropIcon} valueProps={valueProps} />
            <CtaButtonContainer className={variantStyles.heroCtaContainer}>
              <CtaButton
                type="primary2"
                data-event-action="homepage-header"
                data-event-label="Start Free Trial"
                onClick={onCtaClick}
                className={classNames(botClassName('hero-cta-btn'), variantStyles.heroCta)}
              >
                {btnCtaLabel}
              </CtaButton>

              <div className={variantStyles.heroLegalWrapper}>
                <CodeSparkThemedTypography
                  variant="legal"
                  className={classNames(styles.heroSectionTrialLegal, variantStyles.heroLegal)}
                >
                  {trialText}
                </CodeSparkThemedTypography>
              </div>
            </CtaButtonContainer>
          </HeroLeft>

          <HeroRightImage image={heroImage} announcement={announcement} />
        </HeroWrapper>
      </SectionWidth>
    </SectionPaddingVertical>
  );
}

export default HeroRedesign;



// WEBPACK FOOTER //
// ./src/containers/Home/sections/Hero/HeroRedesign.js